import type { RouteRecordRaw } from 'vue-router'

import { HOME } from './route-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/home/Home.vue'),
      name: HOME,
      path: '',
      meta: {
        owners: ['bot-squad-content-front'],
        cache: 'public, max-age=3600, stale-while-revalidate=3600',
        tracking: { contentGroup: 'Homepage' },
      },
    },
  ]
}
